import { EsqueciMinhaSenhaPage } from './esqueci-minha-senha.page';
import { EsqueciMinhaSenhaModel } from 'projects/core/src/lib/core/model/EsqueciMinhaSenhaModel';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';

export class EsqueciMinhaSenhaViewModel {
    constructor() {}

    context: EsqueciMinhaSenhaPage
    esqueciMinhaSenhaModel = new EsqueciMinhaSenhaModel()

    async enviaEsqueciMinhaSenha(loginModel: EsqueciMinhaSenhaModel) {
        const retorno = await this.esqueciMinhaSenhaModel.enviaEsqueciMinhaSenha(loginModel);
        if (retorno.status == ResponseModel.STATUS_OK) {
            this.getContext().retornoSucessoEsqueciMinhaSenha(retorno.data.status);
        } else if (retorno.status == ResponseModel.STATUS_BAD_REQUEST) {
            this.getContext().retornoFalhaEsqueciMinhaSenha(retorno.data.status);
        } else {
            this.getContext().retornoErroEsqueciMinhaSenha('Não foi possível realizar a operação de alteração de senha. Tente novamente')
        }
    }

    getContext(): EsqueciMinhaSenhaPage {
        return this.context
    }

    setContext(context: EsqueciMinhaSenhaPage) {
        this.context = context
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}